import React from 'react'
import Draggable from "../../../DnD/Draggable";
import InputWrapper from "../../../../../components/Input/InputWrapper";

function Number() {
    return (
        <Draggable id="input-number">
            <InputWrapper>
                Number
                <div/>
            </InputWrapper>
        </Draggable>
    )
}

export default Number
